import { createContext, useState } from "react";

export const TokenContext = createContext(null);

function TokenContextProvider({ children }) {
  const [selectedToken, setSelectedToken] = useState(0)
  const [tokenCount, setTokenCount] = useState([])
  const [refreshCards, setRefreshCards] = useState(false)

  // console.log("selectedTokens", selectedToken)

  return (
    <TokenContext.Provider value={{ selectedToken, setSelectedToken, tokenCount, setTokenCount, refreshCards, setRefreshCards }}>
      {children}
    </TokenContext.Provider>
  )
}

export default TokenContextProvider